export default "__VITE_ASSET__9f3e188c__"